import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Moment from 'react-moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import avatar from '@material-ui/core/colors/grey';

import ReceiptStatus from './ReceiptStatus';

import classNames from 'classnames';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  vendor: {
    minWidth: "150px",
    maxWidth: "150px"
  },
  client: {
    maxWidth: "150px",
    minWidth: "150px"
  },
  date: {
    width: "140px",
  },
  total: {
    width: "60px",
  },
});

const ReceiptCard = ({ classes, receipt, client, project, vendor, taxCategory, handleEdit }) => {
  return(
    <Card className={classes.root}>
      <div
        className={classes.content}
        onClick={() => handleEdit(receipt)}
      >
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          {receipt.type && receipt.type.substring(0,1).toUpperCase()}
        </Avatar>
        <div className={classNames(classes.margin, classes.vendor)}>
          {vendor &&
            <Typography noWrap variant="subheading">
              {vendor.name}
            </Typography>
          }
          {taxCategory &&
            <Typography noWrap variant="caption">
              {taxCategory.name}
            </Typography>
          }
        </div>
        <div className={classNames(classes.margin, classes.client)}>
          {client &&
            <Typography noWrap variant="subheading">
              {client.fullName}
            </Typography>
          }
          {project &&
            <Typography noWrap variant="caption">
              {project.jobCode}
            </Typography>
          }
        </div>
        <Moment className={classNames(classes.margin, classes.date)} format="MMM Do, YYYY">{receipt.date}</Moment>
        <div className={classes.divider}></div>
        <Typography className={classNames(classes.margin, classes.total)}>${receipt.total}</Typography>
        <div className={classes.divider}></div>
      </div>
      <div className={classes.margin}>
        <ReceiptStatus receipt={receipt} />
      </div>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { receipt } = props;
  const vendor = receipt.vendorId === undefined
    ? undefined
    : state.vendorsState.find(vendor => vendor.id === receipt.vendorId);
  const client = receipt.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === receipt.clientId);
  const project = receipt.projectId === undefined
    ? undefined
    : state.projectsState.find(project => project.id === receipt.projectId);
  const taxCategory = receipt.taxCategoryId === undefined
    ? undefined
    : state.taxCategoriesState.find(taxCategory => taxCategory.id === receipt.taxCategoryId);

  return {
    client: client,
    project: project,
    vendor: vendor,
    taxCategory: taxCategory,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, null)
)(ReceiptCard);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptCard.jsx